(function () {
  const WORKER_URL = 'https://32bit-bot.lachlan-john-robertson.workers.dev';
  const WELCOME_MESSAGE = "👋 Hey! I'm 32bit-bot — AI-powered, human-backed. Ask me anything about Bitcoin mining, our products, or getting started. A real person from our team monitors these chats and can jump in anytime.";

  let sessionId = null;
  let token = null;
  let turnstileToken = null;
  let pollInterval = null;
  let waitingForHuman = false;

  const toggle = document.getElementById('chatbot-toggle');
  const win = document.getElementById('chatbot-window');
  const closeBtn = document.getElementById('chatbot-close');
  const messages = document.getElementById('chatbot-messages');
  const input = document.getElementById('chatbot-input');
  const sendBtn = document.getElementById('chatbot-send');

  window.onTurnstileSuccess = function (tkn) { turnstileToken = tkn; };

  function addBubble(text, type) {
    const div = document.createElement('div');
    div.className = `chat-bubble ${type}`;
    div.textContent = text;
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function setLoading(loading) {
    sendBtn.disabled = loading;
    input.disabled = loading;
  }

  async function initSession() {
    let attempts = 0;
    while (!turnstileToken && attempts < 20) {
      await new Promise(r => setTimeout(r, 300));
      attempts++;
    }
    if (!turnstileToken) {
      addBubble('Unable to verify your browser. Please refresh and try again.', 'system');
      return false;
    }
    try {
      const resp = await fetch(`${WORKER_URL}/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ turnstileToken }),
      });
      const data = await resp.json();
      if (data.error) {
        addBubble('Too many chats from this device. Please try again later.', 'system');
        return false;
      }
      sessionId = data.sessionId;
      token = data.token;
      return true;
    } catch {
      addBubble('Connection error. Please try again.', 'system');
      return false;
    }
  }

  async function openChat() {
    win.classList.remove('hidden');
    toggle.style.display = 'none';
    if (!sessionId) {
      addBubble(WELCOME_MESSAGE, 'bot');
      setLoading(true);
      const ok = await initSession();
      setLoading(false);
      if (!ok) return;
      startPolling();
    }
  }

  function closeChat() {
    win.classList.add('hidden');
    toggle.style.display = 'flex';
  }

  async function sendMessage() {
    const text = input.value.trim();
    if (!text || !sessionId) return;
    input.value = '';
    addBubble(text, 'user');
    setLoading(true);
    try {
      const resp = await fetch(`${WORKER_URL}/message`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, token, message: text }),
      });
      const data = await resp.json();
      if (data.error) {
        addBubble(
          data.error === 'Message limit reached'
            ? "You've reached the message limit for this session. Refresh the page to start a new chat."
            : 'Something went wrong. Please try again.',
          'system'
        );
      } else if (data.status === 'waiting') {
        waitingForHuman = true;
        addBubble('Our team will reply shortly...', 'system');
      } else if (data.reply) {
        addBubble(data.reply, 'bot');
      }
    } catch {
      addBubble('Connection error. Please try again.', 'system');
    } finally {
      setLoading(false);
    }
  }

  function startPolling() {
    pollInterval = setInterval(async () => {
      if (!sessionId) return;
      try {
        const resp = await fetch(`${WORKER_URL}/poll?sessionId=${sessionId}&token=${encodeURIComponent(token)}`);
        const data = await resp.json();
        if (data.reply) {
          waitingForHuman = false;
          addBubble(data.reply, 'bot');
        }
      } catch { /* silent */ }
    }, 1000);
  }

  toggle.addEventListener('click', openChat);
  closeBtn.addEventListener('click', closeChat);
  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });
})();
